import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Message } from '../models/domain';
import { Account, AccountTransaction, AccountTransactionEntry, FinanceReports, Journal, Ledger, Payment, Transaction } from '../models/finance';

@Injectable({
  providedIn: 'root',
})
export class FinanceService {
  constructor(private httpClient: HttpClient) { }

  //ACCOUNTS API'S
  public createAccount(account: Account): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/account', account);
  }

  public getAccount(id: number): Observable<Account> {
    return this.httpClient.get<Account>(`/api/finance/v1/account/${id}`);
  }

  public getAccounts(company: number, type?: string, disabled?: boolean): Observable<Account[]> {
    return this.httpClient.get<Account[]>(`/api/finance/v1/accounts?company=${company}`, { params: { ...type && { type }, ...(disabled != null && { disabled }) } })
  }

  public updateAccount(id: number, account: Account): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/account/${id}`, account);
  }

  public deleteAccount(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/account/${id}`);
  }

  public getCategory(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/finance/v1/category')
  }

  public getNature(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/finance/v1/nature')
  }

  public toggleAccountStatus(account: Account): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/account/${account.id}`, account);
  }
  //CASHBOOK API'S
  public createJournal(journal: Journal): Observable<Journal> {
    return this.httpClient.post<Journal>('/api/finance/v1/journal', journal);
  }

  public getJournal(id: number): Observable<Journal> {
    return this.httpClient.get<Journal>(`/api/finance/v1/journal/${id}`);
  }

  public getJournals(startDate?: string, endDate?: string, disabled?: boolean): Observable<Journal[]> {
    return this.httpClient.get<Journal[]>(`/api/finance/v1/journals`, { params: { ...startDate && { startDate }, ...endDate && { endDate }, ...(disabled != null && { disabled }) } })
  }

  public updateJournal(id: number, journal: Journal): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/journal/${id}`, journal);
  }

  public deleteJournal(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/journal/${id}`);
  }
  public toggleJournalStatus(journal: Journal): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/journal/${journal.id}`, journal);
  }
  //Transation API'S
  public createTransation(transation: Transaction[]): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/transaction', transation);
  }

  public getTransation(id: number): Observable<Transaction> {
    return this.httpClient.get<Transaction>(`/api/finance/v1/transaction/${id}`);
  }

  public getTransations(journalId:number): Observable<Transaction[]> {
    return this.httpClient.get<Transaction[]>(`/api/finance/v1/transactions?journalId=${journalId}`)
  }

  public updateTransation( transation: Transaction[]): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction`, transation);
  }

  public deleteTransation(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction/${id}`);
  }
  
  public toggleTransationStatus(transation: Transaction): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction/${transation.id}`, transation);
  }
  public deleteJornalEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction/${id}`);
  }

  // Payment API's
  public createPayment(payment: Payment): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/payment', payment);
  }

  public getPayment(id: number): Observable<Payment> {
    return this.httpClient.get<Payment>(`/api/finance/v1/payment/${id}`);
  }

  public getPayments(journalId: number): Observable<Payment[]> {
    return this.httpClient.get<Payment[]>(`/api/finance/v1/payments?journalId=${journalId}`);
  }

  public updatePayment(id: number, payment: Payment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/payment/${id}`, payment);
  }

  public deletePayment(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/payment/${id}`);
  }

  public togglePaymentStatus(payment: Payment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/payment/${payment.id}`, payment);
  }

  // Journel

  public getJournels(
    company: number,
    startDate?: string,
    endDate?: string
  ): Observable<Journal[]> {
    if (company)
      return this.httpClient.get<Journal[]>(
        `/api/finance/v1/journal?company=${company}`
      );
    else {
      return this.httpClient.get<Journal[]>(`/api/finance/v1/journal`);
    }
  }
  public getJournel(id: number): Observable<Journal> {
    return this.httpClient.get<Journal>(`/api/finance/v1/journal/${id}`);
  }
  // public createJournal(journal: Journal): Observable<Journal> {
  //   return this.httpClient.post<Journal>('/api/finance/v1/journal', journal);
  // }
  // public updateJournal(id: number, journal: Journal): Observable<Journal> {
  //   return this.httpClient.put<Journal>(
  //     `/api/finance/v1/journal/${id}`,
  //     journal
  //   );
  // }
  public deleteJournel(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`/api/finance/v1/journal/${id}`);
  }
  public deleteJournelEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/journal-entry/${id}`);
  }
  //ledger
  public getledgers(company: number, acc: number): Observable<Ledger[]> {
    if (company && acc) {
      return this.httpClient.get<Ledger[]>(
        `/api/finance/v1/ledger/${acc}?company=${company}`
      );
    }
  }
  public getAllLedgers(company: number): Observable<Map<string, any[]>> {
    if (company)
      return this.httpClient.get<Map<string, any[]>>(
        `/api/finance/v1/ledger?company=${company}`
      );
    // else {
    //   return this.httpClient.get<Map<string, string>>(`/api/finance/v1/ledger`);
    // }
  }

  // FINANCE REPORT

  public getFinanceReport(type: string, startDate: string, endDate: string): Observable<FinanceReports[]> {
    return this.httpClient.get<FinanceReports[]>(`/api/finance/v1/finance-report`, { params: {type, startDate, endDate } })
  }

  // ACCOUNT TRANSACTION API's
  public createAccountTransaction(accountTransaction: AccountTransaction): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/transaction', accountTransaction);
  }

  public getAccountTransaction(id: number): Observable<AccountTransaction> {
    return this.httpClient.get<AccountTransaction>(`/api/finance/v1/transaction/${id}`);
  }

  public getAccountTransactions(fromDate?:string, toDate?:string, disabled?:boolean): Observable<AccountTransaction[]> {
    return this.httpClient.get<AccountTransaction[]>(`/api/finance/v1/transactions`, { params: { ...fromDate && { fromDate }, ...toDate && { toDate }, ...(disabled != null && { disabled }) } });
  }

  public updateAccountTransaction(id: number, accountTransaction: AccountTransaction): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction/${id}`, accountTransaction);
  }

  public deleteAccountTransaction(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction/${id}`);
  }

  public toggleAccountTransaction(accountTransaction: Payment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction/${accountTransaction.id}`, accountTransaction);
  }

// ACCOUNT TRANSACTION API's
 public createAccountTransactionEntry(accountTransactionEntry: AccountTransactionEntry): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/transaction-entry', accountTransactionEntry);
  }

  public getAccountTransactionEnrty(id: number): Observable<AccountTransactionEntry> {
    return this.httpClient.get<AccountTransactionEntry>(`/api/finance/v1/transaction-entry/${id}`);
  }

  public getAccountTransactionEntries(transactionId: number): Observable<AccountTransactionEntry[]> {
    return this.httpClient.get<AccountTransactionEntry[]>(`/api/finance/v1/transaction-entries?transactionId=${transactionId}`);
  }

  public updateAccountTransactionEntry(id: number, accountTransactionEntry: AccountTransactionEntry): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction-entry/${id}`, accountTransactionEntry);
  }

  public deleteAccountTransactionEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction-entry/${id}`);
  }

  public deleteAllTransactionEntries(ids: number[]): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction-entries`, { params: {ids} });
  }
}
